import { create } from "zustand";

import { User } from "@app-types/common.type";

export interface IUserStore {
  hasSession: boolean;
  activeUser: User | null;
  isPending: boolean;
  isUserConnected: boolean;
  resetUser: () => void;
  setHasSession: (value: boolean) => void;
  setUser: (user: User) => void;
  setIsPending: (value: boolean) => void;
  setIsUserConnected: (value: boolean) => void;
}

const useUserStore = create<IUserStore>((set) => ({
  hasSession: false,
  activeUser: null,
  isPending: true,
  isUserConnected: false,
  resetUser: () => set({ activeUser: null, isUserConnected: false }),
  setHasSession: (value: boolean) => set({ hasSession: value }),
  setUser: (user: User) => set({ activeUser: user }),
  setIsPending: (value: boolean) => set({ isPending: value }),
  setIsUserConnected: (value: boolean) => set({ isUserConnected: value }),
}));

export default useUserStore;
